import Card from "@mui/material/Card"
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from "../../interface/ApplicationState";
import { updateLocalUser } from "../../redux/actions/userActions";
import { alpha, Box, Typography, useTheme } from '@mui/material';
import Slider from "@mui/material/Slider";
import { SignalSourceSection } from "./SignalSourceSection";



export const SignalsSection = () =>
{
  const user = useSelector((state: ApplicationState) => state.userStore.user)

  const dispatch = useDispatch()
  const theme = useTheme()

  return(
    <Card sx={localStyles.card(theme)}>
    <Typography variant="body2" sx={localStyles.copy(theme)}>
      Enable Telegram signal execution and cap how much capital a signal can deploy before it reaches your account.
    </Typography>

    <Box sx={localStyles.toggleWrap(theme)}>
    <FormControlLabel
      control={<Switch checked={user.isSignalsEnabled} onChange={(e) => dispatch(updateLocalUser({ isSignalsEnabled: e.target.checked }))} name="Enable Signals" />}
      label="Enable Signals" />
    </Box>

    <Typography color="textSecondary" sx={{ mt: 1.5 }}>Signals Max Buy in USDT</Typography>

    <Slider
      style={localStyles.signalsSlider}
      max={5000}
      value={user.signalsMaxBuy}
      onChange={(e: any) => {
        dispatch(updateLocalUser({ signalsMaxBuy: e.target.value }))
      }}
      disableSwap
      valueLabelDisplay="on"
    />

    {user.isSignalsEnabled && <SignalSourceSection />}

    </Card>
  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.74),
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
    padding: 1.5,
    boxShadow: "none",
  }),
  copy: (theme: any) => ({
    color: alpha(theme.palette.text.primary, 0.68),
    mb: 1.25,
    maxWidth: 760,
  }),
  toggleWrap: (theme: any) => ({
    p: 1.25,
    borderRadius: "12px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.58),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.45)}`,
  }),
  signalsSlider: {
    marginTop: 50,
    marginLeft: 6,
    marginRight: 6
  }
}
